import { createSlice } from "@reduxjs/toolkit";
import { listColorGroupAction } from "../Action/colorGroupAction";

const colorGroupSlice = createSlice({
  name: "colorGroup",
  initialState: {
    colorGroups: {},
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listColorGroupAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listColorGroupAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colorGroups = action?.payload?.data || action?.payload || {};
      })
      .addCase(listColorGroupAction.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default colorGroupSlice.reducer;
